

import type { ChoiceStep, ChoiceOption, Stat, CardPickSpec } from "./types";
import { CARD_CATALOG } from "./cards";
import type { Rng } from "./dice";
import { defaultRng, rollInt } from "./dice";

export const ACTIVE_DECK_SIZE = 10;


export function xpForLevel(level: number): number {
  return 25 * level * level + 25;
}



export function cumulativeXpToReachLevel(level: number): number {
  if (level <= 1) return 0;
  let total = 0;
  for (let i = 1; i < level; i++) total += xpForLevel(i);
  return total;
}

export interface GrantXpResult {
  newXp: number;
  newLevel: number;
  leveledUp: boolean;
  
  levelsGained: number;
}


export function grantXp(currentXp: number, currentLevel: number, amount: number): GrantXpResult {
  let xp = currentXp + amount;
  let lvl = currentLevel;
  let gained = 0;
  while (xp >= xpForLevel(lvl)) {
    xp -= xpForLevel(lvl);
    lvl += 1;
    gained += 1;
  }
  return { newXp: xp, newLevel: lvl, leveledUp: gained > 0, levelsGained: gained };
}





const STAT_LABEL_RU: Record<Stat, string> = {
  strength: "Сила",
  dexterity: "Ловкость",
  intelligence: "Интеллект",
  wisdom: "Мудрость",
  constitution: "Телосложение",
};

function pickDistinct(pool: string[], n: number, rng: Rng): string[] {
  const copy = [...pool];
  const take = Math.min(n, copy.length);
  const out: string[] = [];
  for (let i = 0; i < take; i++) {
    const idx = rollInt(0, copy.length - 1, rng);
    out.push(copy.splice(idx, 1)[0]);
  }
  return out;
}

function cardStep(id: string, title: string, ids: string[]): ChoiceStep {
  return {
    id,
    title,
    options: ids.map<ChoiceOption>((cardId) => ({
      id: `${id}_${cardId}`,
      label: CARD_CATALOG[cardId]?.name ?? cardId,
      choice: { kind: "addCard", cardId },
    })),
  };
}

export function levelStatSteps(count: number): ChoiceStep[] {
  const stats: Stat[] = ["strength", "dexterity", "intelligence", "wisdom", "constitution"];
  const steps: ChoiceStep[] = [];
  for (let i = 0; i < count; i++) {
    steps.push({
      id: `stat_${i}`,
      title: "Характеристика",
      options: stats.map<ChoiceOption>((stat) => ({
        id: `stat_${i}_${stat}`,
        label: `+1 ${STAT_LABEL_RU[stat]}`,
        choice: { kind: "statPlusOne", stat },
      })),
    });
  }
  return steps;
}

export function cardChoiceStep(pool: string[], n = 3, rng: Rng = defaultRng): ChoiceStep | null {
  const ids = pickDistinct(pool, n, rng);
  if (ids.length === 0) return null;
  return cardStep("card", "Выбери карту", ids);
}

export function levelUpSteps(levels: number, domainPool: string[], rng: Rng = defaultRng): ChoiceStep[] {
  const statSteps = levelStatSteps(levels);
  const out: ChoiceStep[] = [];
  for (let i = 0; i < levels; i++) {
    out.push(statSteps[i]);
    const card = cardChoiceStep(domainPool, 3, rng);
    if (card) out.push({ ...card, id: `levelcard_${i}` });
  }
  return out;
}

export function cardChoiceStepFromSpec(spec: CardPickSpec, domainPool: string[], rng: Rng = defaultRng): ChoiceStep | null {
  const manual = spec.cards && spec.cards.length > 0;
  const pool = manual ? spec.cards! : domainPool;
  const n = manual ? spec.cards!.length : 3;
  return cardChoiceStep(pool, n, rng);
}
